import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonsModule } from '../../commons/commons.module';
import { PagesComponentsModule } from '../components/pages-components.module';
import { AuthProcessPagesComponent } from './auth-process-pages.component';
import { AuthProcessComponentsModule } from './components/auth-process-components.module';

@NgModule({
  declarations: [AuthProcessPagesComponent],
  imports: [
    CommonModule,
    CommonsModule,
    PagesComponentsModule,
    AuthProcessComponentsModule,
  ],
})
export class AuthProcessPagesModule {}
